import { OrderEntity } from "@src/core/features";
import { orderFeatureApi } from "@src/features/order/redux";
import { IUpdateOrderRequest } from "./types";
import { IOrderForm } from '@src/features/order/pages/upsert-order-page/entities';

export const upsertOrderApi = orderFeatureApi.injectEndpoints({
  endpoints: (builder) => ({
    createOrder: builder.mutation<OrderEntity, IOrderForm>({
      invalidatesTags: ['Orders'],
      query: (data) => ({
        url: 'api/v2/orders',
        method: 'POST',
        data,
      })
    }),
    updateOrder: builder.mutation<OrderEntity, IUpdateOrderRequest>({
      invalidatesTags: ['Orders'],
      query: (data) => ({
        url: 'api/v2/orders',
        method: 'PUT',
        data,
      })
    }),
  })
});

export const { useCreateOrderMutation, useUpdateOrderMutation } = upsertOrderApi;